import { tabClasses, tabsClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useContentSwitcherStyles = makeStyles()(theme => ({
  root: {
    '&&': {
      display: 'inline-flex',
      maxWidth: '100%',
      backgroundColor: theme.palette.background.default,
    },
    [`& .${tabsClasses.flexContainer}`]: {
      padding: theme.spacing(0.5),
      gap: theme.spacing(0.5),
    },
    [`& .${tabClasses.root}`]: {
      color: theme.palette.text.secondary,
      transitionProperty: 'color, background-color',
      transitionDuration: `${theme.transitions.duration.short}ms`,
      minWidth: 'auto',
      '&:hover': {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.grey[900],
      },
      [`&.${tabClasses.selected}`]: {
        boxShadow:
          '0px 0px 15px 0px rgba(31, 34, 38, 0.10), 0px 0px 5px 0px rgba(31, 34, 38, 0.10)',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
      },
    },
  },
  sizeTiny: {
    '&&': {
      borderRadius: theme.shape.borderRadiusMd, // ex 11,
      minHeight: 28,
      [`& .${tabClasses.root}`]: {
        minHeight: 24,
        padding: theme.spacing(0.5, 2),
        borderRadius: theme.shape.borderRadiusSm,
        fontSize: 14,
        fontWeight: 500,
      },
    },
  },
  sizeSmall: {
    '&&': {
      borderRadius: theme.shape.borderRadiusMd, // ex 11,
      minHeight: 32,
      [`& .${tabClasses.root}`]: {
        minHeight: 28,
        padding: theme.spacing(1, 3),
        borderRadius: theme.shape.borderRadiusSm,
        fontSize: 14,
        fontWeight: 500,
      },
    },
  },
  sizeMedium: {
    '&&': {
      minHeight: 40,
      borderRadius: theme.shape.borderRadiusMd, // ex 14,
      [`& .${tabClasses.root}`]: {
        minHeight: 36,
        fontSize: 16,
        fontWeight: 600,
        padding: theme.spacing(1.5, 4),
        borderRadius: theme.shape.borderRadiusMd,
      },
    },
  },
  sizeLarge: {
    '&&': {
      borderRadius: theme.shape.borderRadius, // ex 17
      minHeight: 48,
      [`& .${tabClasses.root}`]: {
        minHeight: 44,
        fontSize: 16,
        fontWeight: 600,
        padding: theme.spacing(2.5, 5),
        borderRadius: theme.shape.borderRadius,
      },
    },
  },
}));
